import { MENTION_TYPE } from "@/constants";
import { MentionV4 } from "@/types/MentionCard";

export function categorizeMentionsByContext(mentions: MentionV4[]) {
  const titleMention = mentions.find(
    (mention) => mention.context === MENTION_TYPE.EPISODE_NAME
  );

  const nonTitleMentions = titleMention
    ? mentions.filter((mention) => mention.id !== titleMention?.id)
    : mentions;

  const otherMentions = nonTitleMentions.toSorted((a, b) => {
    const isADescMention = a.context === MENTION_TYPE.EPISODE_DESCRIPTION;
    const isBDescMention = b.context === MENTION_TYPE.EPISODE_DESCRIPTION;

    if (!isADescMention && isBDescMention) {
      return 1;
    }

    if (isADescMention && !isBDescMention) {
      return -1;
    }

    return 0;
  });

  return {
    titleMention,
    otherMentions,
  };
}
